// ¿Ya se le hizo la pregunta del NPS a esta CUENTA en los últimos 30 días?
//
// Nace del reclamo del fundador (2026-10-04, "el widget de recomendar MiPAE
// aparece siempre"): la cuota mensual vivía SOLO en localStorage
// (lib/microEncuestas.js), así que respondía en el computador y el teléfono no
// se enteraba, y el WebView de Android purgado lo volvía a mostrar. En
// producción tenía 7 respuestas en un mes, desde la web y desde Android,
// contra una regla de "una vez al mes". Misma causa y mismo arreglo que las
// novedades (E10, 2026-09-28) y el reto del día (#996): el dato sigue a la
// cuenta.
//
// La cuenta ya lo sabe sin tabla nueva: los eventos `nps_*` de `eventos_v2`,
// que la persona puede leer de sí misma (RLS `eventos_v2_user_read_own`, índice
// (user_id, created_at)). Son dato de la encuesta, jamás de un paciente.
//
// Archivo aparte de microEncuestas.js a propósito: ese es dominio puro sin
// Supabase y lo usan más superficies.

import { supabase } from './supabase';
import { MS_MES } from './microEncuestas';

// Toda aparición cuenta: mostrada, respondida o descartada.
export const EVENTOS_NPS = Object.freeze(['nps_mostrado', 'nps_respondido', 'nps_descartado']);

// true = la cuenta ya la vio este mes · false = libre · null = no se sabe
// (error o sin red). El llamador trata null como "no mostrar": fail-safe hacia
// no molestar, la doctrina de microEncuestas.
export async function npsVistoEnCuenta(userId, ahora = Date.now()) {
  if (!userId) return null;
  try {
    const { data, error } = await supabase
      .from('eventos_v2')
      .select('created_at')
      .eq('user_id', userId)
      .in('evento', EVENTOS_NPS)
      .gte('created_at', new Date(ahora - MS_MES).toISOString())
      .order('created_at', { ascending: false })
      .limit(1);
    if (error || !Array.isArray(data)) return null;
    return data.length > 0;
  } catch {
    return null;
  }
}
